import WPLoader from "./WPLoader.jsx";

export default WPLoader;
